import { Button } from "@/components/ui/button";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const LINKS = [
  { label: "Care+ Members", id: "care-plus" },
  { label: "Services", id: "services" },
  { label: "Spin & Win", id: "spin" },
  { label: "Insurance", id: "insurance" },
  { label: "Contact", id: "contact" },
];

export default function Navbar() {
  return (
    <nav className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-[#E4E4E7]" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 sm:h-[72px] flex items-center justify-between gap-4">
        <button
          data-testid="navbar-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="shrink-0"
          aria-label="AutoHQ home"
        >
          <img src="/logo-on-light.png" alt="AutoHQ — Keep Your Auto Moving" className="h-9 sm:h-11 w-auto" />
        </button>
        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`navbar-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-semibold text-[#52525B] hover:text-[#0A0A0A] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button asChild
            data-testid="navbar-my-account-cta"
            variant="outline"
            className="hidden sm:inline-flex border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white font-bold rounded-sm h-10 px-4 text-sm"
          >
            <a href="/me">My Coupons</a>
          </Button>
          <Button
            data-testid="navbar-callback-cta"
            onClick={() => scrollTo("callback")}
            className="bg-[#FF5A00] hover:bg-[#E04F00] text-white font-bold rounded-sm h-10 px-5 text-sm"
          >
            Request Callback
          </Button>
        </div>
      </div>
    </nav>
  );
}
